import barba from '@barba/core';
import views from './views/views';
import transitions from './transitions/transitions';

export default class Spa {
	constructor() {
		let scrollX = 0;
		let scrollY = 0;

		if (history.scrollRestoration) {
			history.scrollRestoration = 'manual';
		}

		barba.hooks.leave(({ current, next, trigger }) => {
			if (trigger !== 'back') {
				scrollX = barba.history.current.scroll.x;
				scrollY = barba.history.current.scroll.y;
			}

			document.dispatchEvent(new Event('leave'));
		});

		barba.hooks.enter(({ current, next, trigger }) => {
			if (trigger == 'back') {
				window.scrollTo(scrollX, scrollY);
			} else {
				window.scrollTo(0, 0);
			}
		});

		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			const blessEvent = new Event('bless', {
				bubbles: true,
			});

			if (next.namespace == 'home') {
				document.body.classList.add('body__dark--footer');
			} else {
				document.body.classList.remove('body__dark--footer');
			}

			if (next.namespace == 'template-cases' || next.namespace == 'single-post') {
				document.body.classList.add('body__nav--purple');
			} else {
				document.body.classList.remove('body__nav--purple');
			}

			next.container.dispatchEvent(blessEvent);
		});

		barba.hooks.after(({ current, next, trigger }) => {});

		// Barba settings, transitions and views
		barba.init({
			// debug: window.WPDATA.env == 'development' ? true : false,
			debug: true,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}

				return false;
			},
			prevent: ({ el, event, href }) => {
				if (/\.(jpg|jpeg|png|webp|avif|gif|svg|pdf)$/.test(href)) {
					return true;
				}
			},
			views: views,
			transitions: transitions,
		});
	}
}
